import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import Training_Logo from "../../Images/training.svg";
import "./DashboardTraining.scss";
import Edit from "../../Images/Icon material-edit.svg";
import Delete from "../../Images/delete_red_icon.svg";
import moment from "moment";
import Cookies from "universal-cookie";
// import Button from "../../components/common/Button";
import _ from "lodash";
import { Tooltip } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API, STATUS, ROLE, APP_ROUTES } from "../../globals/constants/index";
import Info from "../../Images/yellow_info_icon.svg";
import { Button } from "bootstrap";
import Google from "../../Images/google-cloud.svg";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import Aws from "../../Images/aws-cloud.svg";
import api_call from "../../globals/common_utilities/axios_old";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";

function DashboardTraining(props) {
  const navigate = useNavigate();
  const [trainingList, setTrainingList] = useState();
  const [isLoading, setIsloading] = useState(false);

  // const handleSelect = (training) => {
  //   let data = trainingList.filter((item) => item.id === training.id);
  //   console.log("data-----", data);
  //   navigate(APP_ROUTES.TRAINING_LISTING_DETAILS, {
  //     state: {
  //       trainingList: trainingList,
  //       training: data[0],
  //       id: data[0]?.id,
  //       redirect: "dashboard",
  //     },
  //   });
  // };
  const handleSelect = async (training) => {
    let data = trainingList.filter((item) => item.id === training.id);
    let startDate = moment().format("YYYY-MM-DD");
    let endDate = moment().format("YYYY-MM-DD");
    setIsloading(true);
    const response = await api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.TRAINING_BY_ID
      }?tid=${training?.id}`
    );
    console.log("data-----", response);
    if (response.status === 200) {
      setIsloading(false);
      let data_ = [response?.data?.data];
      console.log("props training=====", response?.data?.data);
      let training_data = data_.map((res) => {
        let data = {
          ...res,
          status_colour:
            res?.status === "pending"
              ? status_json.pending
              : res?.status === "completed"
              ? status_json.completed
              : res?.status === "cancel"
              ? status_json.cancel
              : res?.status === "running"
              ? status_json.running
              : res?.status === "in-progress"
              ? status_json.inprogress
              : status_json.completed,
          noofdaysTraininig:
            moment(res?.session_end_date).diff(
              res?.session_start_date,
              "days"
            ) === 0
              ? 1
              : moment(res?.session_end_date).diff(
                  res?.session_start_date,
                  "days"
                ),
        };
        let dataRange = res?.training_dates?.filter(
          (data) =>
            moment(data.session_start_date).format("YYYY-MM-DD") >= startDate &&
            moment(data.session_end_date).format("YYYY-MM-DD") <= endDate
        );
        console.log("check date tange data----", dataRange);
        if (dataRange.length > 0) {
          let orderDate = _.orderBy(dataRange, ["session_start_date"], ["asc"]);
          let days = dataRange.map((data) => data.day);
          let diff = orderDate.filter(
            (day) => today <= day?.session_start_date
          );
          data.endDate = moment(
            orderDate[orderDate.length - 1]?.session_end_date
          ).format("Do MMM YYYY");
          data.startDate = moment(orderDate[0]?.session_start_date).format(
            "Do MMM "
          );
          data.startTime = moment(orderDate[0]?.session_start_date)
            .add(15, "minutes")
            .format("h:mm a");
          data.endTime = moment(
            orderDate[orderDate.length - 1]?.session_end_date
          )
            .subtract(15, "minutes")
            .format("h:mm a");
          console.log(
            "check date and time----",
            res?.title,
            res?.session_end_date,
            res?.session_start_date,
            moment(res?.session_end_date).format("h:mm a"),
            moment(res?.session_start_date).format("h:mm a")
          );
          data.diffs = moment(diff[0]?.session_start_date).diff(today, "days");
          if (days.every((data) => data === null)) {
            data.days = res?.days;
          } else {
            console.log("inside days", days);
            data.days = res?.days;
          }
        } else {
          if (res?.cloud_type === "GCP") {
            let days = res?.training_dates.map((data) => data.day);
            let end_day_chk = moment.utc(res?.session_end_date);
            let start_day_chk = moment.utc(res?.session_start_date);
            data.endDate = moment(res?.session_end_date).format("Do MMM YYYY");
            data.startDate = moment(res?.session_start_date).format("Do MMM ");
            data.startTime =
              res?.cloud_type === "GCP"
                ? moment(res?.session_start_date).format("h:mm a")
                : moment(res?.session_start_date).add(15, "minutes").format("h:mm a");
            data.endTime =
              res?.cloud_type === "GCP"
                ? moment(res?.session_end_date).format("h:mm a")
                : moment(res?.session_end_date).subtract(15, "minutes").format("h:mm a");
            data.diffs = moment(res?.session_start_date).diff(
              moment(Date.now()),
              "days"
            );
            console.log(
              "check date and time ---hjgjgjj----",
              res?.title,
              res?.session_end_date,
              res?.session_start_date,
              moment(res?.session_end_date).format("h:mm a"),
              moment(res?.session_start_date).format("h:mm a")
            );
            data.diffs = Math.sign(data.diffs) === -1 ? 0 : data.diffs;
            data.days = res?.days;
          } else {
            let days = res?.training_dates.map((data) => data.day);
            let end_day_chk = moment.utc(res?.session_end_date);
            let start_day_chk = moment.utc(res?.session_start_date);
            data.endDate = moment(res?.session_end_date).format("Do MMM YYYY");
            data.startDate = moment(res?.session_start_date).format("Do MMM ");
            data.startTime =
              res?.cloud_type === "GCP"
                ? moment(res?.session_start_date).format("h:mm a")
                : moment(res?.session_start_date).format("h:mm a");
            data.endTime =
              res?.cloud_type === "GCP"
                ? moment(res?.session_end_date).format("h:mm a")
                : moment(res?.session_end_date).format("h:mm a");
            data.diffs = moment(res?.session_start_date).diff(
              moment(Date.now()),
              "days"
            );

            console.log("check date and time===aws", res?.title);
            data.diffs = Math.sign(data.diffs) === -1 ? 0 : data.diffs;
            if (days.every((data) => data === null)) {
              data.days = res?.days;
            } else {
              data.days = [];
              data.days = days;
            }
          }
        }
        return data;
      });
      navigate(APP_ROUTES.TRAINING_LISTING_DETAILS, {
        state: {
          trainingList: trainingList,
          training: training_data[0],
          id: training_data[0]?.id,
          redirect: "dashboard",
        },
      });
    } else {
      setIsloading(false);
    }
  };
  const status_json = {
    pending: {
      color: "white",
      background: "#FE9000",
      // color: '#FE9000',
      // background: '#2B251E',
      status: "Upcoming Training",
    },
    completed: {
      color: "white",
      background: "#1b18e7",
      // color: '#1b18e7',
      // background: '#2b365c9e',
      status: "Completed Training",
    },
    cancel: {
      color: "white",
      background: "#ed0c0c",
      // color: '#ed0c0c',
      // background: '#893a3a59',
      status: "Cancelled Training",
    },
    running: {
      color: "white",
      background: "#0BB427",
      // color: '#0BB427',
      // background: '#0B3F1B',
      status: "Running Training",
    },
    inprogress: {
      color: "#fff",
      background: "#a367a6",
      status: "Training in progress",
    },
  };
  var startDate = moment().utc().startOf("week").format("YYYY-MM-DD");
  var endDate = moment().utc().endOf("week").format("YYYY-MM-DD");
  var today = moment().format("YYYY-MM-DD");
  useEffect(() => {
    let data = props.training;
    console.log("props training=====", props.training);
    let training_data = data.map((res) => {
      let data = {
        ...res,
        status_colour:
          res?.status === "pending"
            ? status_json.pending
            : res?.status === "completed"
            ? status_json.completed
            : res?.status === "cancel"
            ? status_json.cancel
            : res?.status === "running"
            ? status_json.running
            : res?.status === "in-progress"
            ? status_json.inprogress
            : status_json.completed,
        noofdaysTraininig:
          moment(res?.session_end_date).diff(
            res?.session_start_date,
            "days"
          ) === 0
            ? 1
            : moment(res?.session_end_date).diff(
                res?.session_start_date,
                "days"
              ),
      };
      let dataRange = res?.training_dates?.filter(
        (data) =>
          moment(data.session_start_date).format("YYYY-MM-DD") >= startDate &&
          moment(data.session_end_date).format("YYYY-MM-DD") <= endDate
      );
      console.log("check date tange data----", dataRange);
      if (dataRange.length > 0) {
        let orderDate = _.orderBy(dataRange, ["session_start_date"], ["asc"]);
        let days = dataRange.map((data) => data.day);
        let diff = orderDate.filter((day) => today <= day?.session_start_date);
        data.endDate = moment(
          orderDate[orderDate.length - 1]?.session_end_date
        ).format("Do MMM YYYY");
        data.startDate = moment(orderDate[0]?.session_start_date).format(
          "Do MMM "
        );
        data.startTime = moment(orderDate[0]?.session_start_date)
          .add(15, "minutes")
          .format("h:mm a");
        data.endTime = moment(orderDate[orderDate.length - 1]?.session_end_date)
          .subtract(15, "minutes")
          .format("h:mm a");
        console.log(
          "check date and time----",
          res?.title,
          res?.session_end_date,
          res?.session_start_date,
          moment(res?.session_end_date).format("h:mm a"),
          moment(res?.session_start_date).format("h:mm a")
        );
        data.diffs = moment(diff[0]?.session_start_date).diff(today, "days");
        if (days.every((data) => data === null)) {
          data.days = res?.days;
        } else {
          console.log("inside days", days);
          data.days = res?.days;
        }
      } else {
        if (res?.cloud_type === "GCP") {
          let days = res?.training_dates.map((data) => data.day);
          let end_day_chk = moment.utc(res?.session_end_date);
          let start_day_chk = moment.utc(res?.session_start_date);
          data.endDate = moment(res?.session_end_date).format("Do MMM YYYY");
          data.startDate = moment(res?.session_start_date).format("Do MMM ");
          data.startTime =
            res?.cloud_type === "GCP"
              ? moment(start_day_chk).format("h:mm a")
              : moment(start_day_chk).add(15, "minutes").format("h:mm a");
          data.endTime =
            res?.cloud_type === "GCP"
              ? moment(end_day_chk).format("h:mm a")
              : moment(end_day_chk).subtract(15, "minutes").format("h:mm a");
          data.diffs = moment(res?.session_start_date).diff(
            moment(Date.now()),
            "days"
          );
          console.log(
            "check date and time",
            res?.title,
            res?.session_end_date,
            res?.session_start_date,
            moment(res?.session_end_date).format("h:mm a"),
            moment(res?.session_start_date).format("h:mm a")
          );
          data.diffs = Math.sign(data.diffs) === -1 ? 0 : data.diffs;
          data.days = res?.days;
        } else {
          let days = res?.training_dates.map((data) => data.day);
          let end_day_chk = moment.utc(res?.session_end_date);
          let start_day_chk = moment.utc(res?.session_start_date);
          data.endDate = moment(res?.session_end_date).format("Do MMM YYYY");
          data.startDate = moment(res?.session_start_date).format("Do MMM ");
          data.startTime =
            res?.cloud_type === "GCP"
              ? moment(start_day_chk).format("h:mm a")
              : moment(start_day_chk).format("h:mm a");
          data.endTime =
            res?.cloud_type === "GCP"
              ? moment(end_day_chk).format("h:mm a")
              : moment(end_day_chk).format("h:mm a");
          data.diffs = moment(res?.session_start_date).diff(
            moment(Date.now()),
            "days"
          );

          console.log("check date and time===aws", res?.title);
          data.diffs = Math.sign(data.diffs) === -1 ? 0 : data.diffs;
          if (days.every((data) => data === null)) {
            data.days = res?.days;
          } else {
            data.days = [];
            data.days = days;
          }
        }
      }
      console.log("check the data of training dates", data);
      return data;
    });
    setTrainingList(training_data);
    console.log("check ", training_data);
  }, [props.training]);
  return (
    <>
      <Stack
        className={
          props.check_image_data ? "trainingDeatils_height" : "trainingDeatils"
        }
      >
        <Grid container>
          <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
            <Typography className="training_heading">
              Today's Trainings
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={2}
            lg={2}
            xl={2}
            className="view_all_training"
          >
            {/* <Button
              role="primary"
              value="View All Training"
              onClick={() => navigate("/training")}
              className="view_training"
            /> */}
            <button
              onClick={() => navigate("/training")}
              className="dasboard_view_training"
            >
              View All Training
            </button>
          </Grid>
        </Grid>

        <Stack className="trainingBg">
          {props.training.length === 0 ? (
            <Typography className=" center_align">
              No Training Scheduled
            </Typography>
          ) : (
            props.training.map((item) => {
              return (
                <Stack className="training_info">
                  <Stack>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                        {item.cloud_type === "GCP" ? (
                          <img
                            src={Google}
                            className="set_padding logo_image "
                          />
                        ) : (
                          <img src={Aws} className="set_padding logo_image " />
                        )}
                      </Grid>
                      <Grid item xs={8} sm={8} md={9} lg={9} xl={9}>
                        <Stack className="set_padding">
                          <Grid container>
                            <Typography className="training_Name">
                              Training Name - {item.title}
                            </Typography>
                          </Grid>
                          <Typography className="date">
                            {moment(item.session_start_date).format(
                              "DD/MM/YYYY"
                            )}{" "}
                            -{" "}
                            {moment(item.session_end_date).format("DD/MM/YYYY")}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                        <Stack
                          className={
                            item.status === "running"
                              ? "running_Status"
                              : item.status === "in-progress"
                              ? "inprogess_Status"
                              : item.status === "completed"
                              ? "completed_status"
                              : item.status === "cancel"
                              ? "cancel_Status"
                              : "upcoming_Status"
                          }
                        >
                          {item.status === "running"
                            ? "Running Training"
                            : item.status === "in-progress"
                            ? "Training in progress"
                            : item.status === "completed"
                            ? "Completed Training"
                            : item.status === "cancel"
                            ? "Cancelled Training"
                            : "Upcoming Training"}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                  <Stack className="vm">
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={3}
                        lg={3}
                        xl={3}
                        className="border_Left"
                      >
                        <Stack className="set_padding">
                          <Typography className="vm_Details">Zone</Typography>
                          <Typography className="vm_Info">
                            {item.zone}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        lg={4}
                        xl={4}
                        className="border_Left"
                      >
                        <Stack className="set_padding">
                          <Typography className="vm_Details">
                            No.of Student Attended
                          </Typography>
                          <Typography className="vm_Info">
                            {item.users_trainings.length === 0
                              ? 0
                              : item.users_trainings[0].total_student_count}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        lg={4}
                        xl={4}
                        className="border_Left"
                      >
                        <Stack className="set_padding">
                          <Typography className="vm_Details">
                            Frequency
                          </Typography>

                          <Typography className="vm_Info">
                            {JSON.parse(item.days).toString()}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                        <Stack direction="row">
                          <Stack className="set_padding info_icon">
                            <Tooltip title="Info" placement="top-start" arrow>
                              <img
                                src={Info}
                                onClick={() => handleSelect(item)}
                              />
                            </Tooltip>
                          </Stack>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                </Stack>
              );
            })
          )}
        </Stack>
      </Stack>
      {isLoading && <MultiLine_Spinner />}
    </>
  );
}

export default DashboardTraining;
